exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "display-address {\n  display: flex-inline;\n}\ndisplay-address > * > *:not(:last-child)::after {\n  display: inline-block;\n  content: ',';\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"plugins":[{}]}!./src/app/common/components/display-address/display-address.component.less
// module id = rMv5
// module chunks = 1